import type { SceneInfo } from '~/types/interfaces'

export function useSceneAccess() {
  const gameState = useGameStateStore()

  const scenes = computed(() => gameState.scenes)
  // const flags = computed(() => gameState.flags)

  // const getSceneInfo = (sceneId: string): SceneInfo => {
  //   return scenes.value?.[sceneId] || dummySceneInfo
  // }

  const visibleScenes = computed(() => {
    return Object.keys(scenes.value || {}).filter(sceneId => isSceneVisible(sceneId))
  })

  const listVisibleChildren = (sceneId: string): SceneInfo[] => {
    return Object.values(scenes.value || {}).filter(scene => scene.parentId === sceneId && isSceneVisible(scene.sceneId))
  }

  const coordX = (sceneId: string): number => {
    return scenes.value?.[sceneId]?.coordX || 0
  }
  const coordY = (sceneId: string): number => {
    return scenes.value?.[sceneId]?.coordY || 0
  }

  const isDisabled = (sceneId: string): boolean => {
    const sceneInfo = scenes.value?.[sceneId]
    if (!sceneInfo) {
      return true
    }
    if (sceneInfo.disabled) {
      return true
    }
    return false
  }

  const isSceneVisible = (sceneId: string): boolean => {
    const sceneInfo = scenes.value?.[sceneId]
    if (!sceneInfo) {
      return false
    }
    return sceneInfo.isVisible && !isDisabled(sceneId)
  }

  const isSceneUnlocked = (sceneId: string): boolean => {
    const sceneInfo = scenes.value?.[sceneId]
    if (!sceneInfo) {
      return false
    }
    return sceneInfo.isUnlocked && !isDisabled(sceneId)
  }

  const isScenePurchased = (sceneId: string): boolean => {
    const sceneInfo = scenes.value?.[sceneId]
    if (!sceneInfo) {
      return false
    }
    return sceneInfo.isPurchased && !isDisabled(sceneId)
  }

  const isSceneCleared = (sceneId: string): boolean => {
    const sceneInfo = scenes.value?.[sceneId]
    if (!sceneInfo) {
      return false
    }
    return sceneInfo.isCleared && !isDisabled(sceneId)
  }

  const isSceneMarked = (sceneId: string): boolean => {
    const sceneInfo = scenes.value?.[sceneId]
    if (!sceneInfo) {
      return false
    }
    return sceneInfo.isMarked && !isDisabled(sceneId)
    // if (sceneId === `wld_encodia.${sceneId}:MARKED`) {
    //   // return gameState.hasFlag('CLEARED:wld_encodia.aboutUserInfo') && !gameState.hasFlag('CLEARED:wld_beginnersPort.enter')
    // }
    // // if (sceneId === 'wld_beginnersPort') {
    // //   return gameState.hasFlag('CLEARED:wld_encodia.aboutUserInfo') && !gameState.hasFlag('CLEARED:wld_beginnersPort.enter')
    // // }
    // // if (sceneId === 'wld_slumberingBeach') {
    // //   return gameState.hasFlag('VISIBLE:wld_slumberingBeach') && !gameState.hasFlag('CLEARED:wld_slumberingBeach.click')
    // // }
    // return false
  }

  // const textForConditionToUnlock = (sceneId: string): string => {
  //   // const sceneInfo = gameState.getSceneInfo(sceneId)
  //   const sceneInfo = scenes.value?.[sceneId]
  //   return sceneInfo ? sceneInfo.conditionToUnlock : '無条件で解放'
  // }

  return { visibleScenes, listVisibleChildren, coordX, coordY, isSceneVisible, isSceneUnlocked, isScenePurchased, isSceneMarked, isSceneCleared }
}
